/**
 * Where the leaderboard lives.
 *
 * Both values are safe in client code. The publishable key can read the
 * board's public columns and call start_run / submit_run, and nothing else:
 * the table can't be written to directly, so a score only gets in through
 * submit_run's checks (supabase/migrations).
 *
 * Blank these out and the game plays normally, with the leaderboard reporting
 * itself as unconfigured rather than failing.
 */
module.exports = {
  url: 'https://dgcxkjvprjxnlfljjwsg.supabase.co',
  anonKey: 'sb_publishable_P0aZosUEtEnZUQ5noT0KyQ_jxW9UYVa'
};
